'use client';

import { useEffect } from 'react';

import { registerNativeLanguageHandlers } from '../lib/bridge/sync-native-locale';

/** 全局尽早注册 getH5Language，供 Native Bridge 就绪后拉取当前语言。 */
export function NativeLocaleBridgeSync() {
  useEffect(() => {
    registerNativeLanguageHandlers();
  }, []);

  return null;
}
